import baseApi from '../../base.api'

export const onMarkNotificationsAsReadQueryStarted = async (arg, { dispatch, queryFulfilled }) => {
    const patchResult = dispatch(
        baseApi.util.updateQueryData('fetchNotifications', undefined, draft => {
            draft.notifications.forEach(notification => {
                if (arg.ids.includes(notification.id)) {
                    console.log('notification', notification.id)
                    notification.read = true
                }
            })

            draft.totalUnread -= arg.ids.length
        }),
    )

    try {
        await queryFulfilled
    } catch {
        patchResult.undo()
    }
}

export const onMarkAllNotificationsAsReadQueryStarted = async (arg, { dispatch, queryFulfilled }) => {
    const patchResult = dispatch(
        baseApi.util.updateQueryData('fetchNotifications', undefined, draft => {            
            draft.notifications.forEach(notification => {
                notification.read = true
            })

            draft.totalUnread = 0
        }),
    )

    try {
        await queryFulfilled
    } catch {
        patchResult.undo()
    }
}
